// extracted by mini-css-extract-plugin
module.exports = {"root":"Products_root__nXKPR"};